/***
 * Imports
 */
import { Feature } from "ol";
import { fromLonLat } from "ol/proj.js";
import TileLayer from "ol/layer/Tile";
import OSM from "ol/source/OSM";
import TileWMS from "ol/source/TileWMS.js";
import { Point } from "ol/geom";
import VectorLayer from "ol/layer/Vector.js";
import VectorSource from "ol/source/Vector.js";
import { Circle as CircleStyle, Fill, Stroke, Style } from "ol/style.js";
import LayerSwitcher from "ol-layerswitcher";
import BingMaps from "ol/source/BingMaps.js";
import { Cluster, XYZ } from "ol/source.js";
import StadiaMaps from "ol/source/StadiaMaps.js";
import ImageWMS from "ol/source/ImageWMS.js";
import { getActualMap } from "./globalContext";
import {
  GEOSERVER_BASE_URL,
  GEOSERVER_WMS_URL,
  GEOSERVER_WORKSPACE,
} from "./config/api.js";
import MultiPoint from "ol/geom/MultiPoint.js";
import GeoJSON from "ol/format/GeoJSON.js";
import { ImageArcGISRest } from "ol/source.js";
import { Image as ImageLayer } from "ol/layer.js";
import { transform } from "ol/proj.js";
import { Polygon } from "ol/geom";

/**
 * Variables
 */
const wmsUrl = GEOSERVER_WMS_URL;

/**
 * Function WFS Request
 *
 * Requests WFS Data from GIS Servber and adds it to the MAP
 *
 * @export
 * @param {*} map
 * @ToDo Copy From Searchfundtion
 */
export function wfsRequestAllTrees(map) {
  // const requestURLJSON =
  // "https://gis.treeclimatedb.de/geoserver/wfs?service=WFS&version=2.0.0&request=GetFeature&typeName=treeclimatedb:treesimport&outputFormat=application/json";
  var wfsRequestUrl = `${GEOSERVER_BASE_URL}ows?service=WFS&version=2.0.0&request=GetFeature&typeName=${GEOSERVER_WORKSPACE}:treesimport&propertyName=lokalenr&outputFormat=application/json`;
  const features = [];
  var distance = 100;
  var minDistance = 10;

  // Get all Trees and Coordinates
  fetch(wfsRequestUrl)
    .then((r) => r.json())
    .then(function (data) {
      // Every Tree as Feature
      data.features.forEach(function (item) {
        var singleFeatureToPush = new Feature({
          geometry: new Point(fromLonLat([item.bbox[1], item.bbox[0]])),
        });

        features.push(singleFeatureToPush);
      });

      // All Features to VectorSource
      const vectorSource = new VectorSource({
        features,
      });

      // Create a Cluster
      const clusterSource = new Cluster({
        distance: parseInt(distance, 10),
        minDistance: parseInt(minDistance, 0),
        source: vectorSource,
      });

      // Style the Cluster
      const styleCache = {};
      const clusters = new VectorLayer({
        source: clusterSource,
        title: "Bäume - Gruppiert",
        name: "Bäume - Gruppiert",
        visible: true,
        style: function (feature) {
          const size = feature.get("features").length;
          let style = styleCache[size];
          if (!style) {
            style = new Style({
              image: new Icon({
                anchor: [0.5, 0.5],
                anchorXUnits: "fraction",
                anchorYUnits: "fraction",
                displacement: [0, 0],
                opacity: 0.9,
                scale: 0.1,
                src: "./img/icons/TreeClimategreen.png",
              }),
              text: new Text({
                text: size.toString(),
                fill: new Fill({
                  color: "#000000",
                }),
              }),
            });
            styleCache[size] = style;
          }
          return style;
        },
      });
      // Add Data to map and Layer switcher
      map.addLayer(clusters);
    });
}

/**
 * Generate all Maps and overlays
 *
 * @export
 * @return {*} a Array with TileLayers
 */
export function getMapsAndOverlays() {
  var mapsAndTilesArray = [];
  mapsAndTilesArray.push(
    new TileLayer({
      title: "Karte - OpenStreetmap",
      name: "OpenStreetmap",
      type: "base",
      source: new OSM(),
    }),
  );

  mapsAndTilesArray.push(
    new TileLayer({
      title: "Karte - Sentinel Satellit",
      visible: false,
      source: new TileWMS({
        attributions: [
          "© Europäische Union, enthält Copernicus Sentinel-2 Daten 2020, verarbeitet durch das Bundesamt für Kartographie und Geodäsie (BKG)",
        ],
        attributionsCollapsible: false,
        params: { LAYERS: "sentinel2-de:rgb", TILED: true },
        url: "https://sgx.geodatenzentrum.de/wms_sentinel2_de",
        maxZoom: 20,
      }),
    }),
  );

  mapsAndTilesArray.push(
    new TileLayer({
      maxZoom: 20,
      title: "Karte - Esri Satellit",
      visible: false,
      source: new XYZ({
        attributions: [
          "Powered by Esri",
          "Source: Esri, DigitalGlobe, GeoEye, Earthstar Geographics, CNES/Airbus DS, USDA, USGS, AeroGRID, IGN, and the GIS User Community",
        ],
        attributionsCollapsible: false,
        url: "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
      }),
    }),
  );

  /* !!! CROSS ORIGIN RESSOURCE BLOCKED !!!
  mapsAndTilesArray.push(
    new TileLayer({
      title: "Drought",
      visible: false,
      source: new XYZ({
        attributions: [
          "Powered by Esri",
          "Source: Esri, DigitalGlobe, GeoEye, Earthstar Geographics, CNES/Airbus DS, USDA, USGS, AeroGRID, IGN, and the GIS User Community",
        ],
        attributionsCollapsible: false,
        url: "https://land.discomap.eea.europa.eu/arcgis/services/Drought/Growing_Season_Mean_Soil_Moisture_2000_2019/MapServer/WMSServer?request=GetCapabilities&service=WMS",
        maxZoom: 23,
      }),
    })
  );*/

  mapsAndTilesArray.push(
    new TileLayer({
      title: "Karte - Bing Satellit Hybrid",
      visible: true,
      preload: Infinity,
      source: new BingMaps({
        key: "AtfmzTgvISAS9IXpA4S7NDMz0EG7EXkR_SWuy25sHz4LW6PqfqyQJ5x0deVFuujO",
        //            imagerySet: bingStyles[i],
        imagerySet: "AerialWithLabels",
        culture: "de-DE",
        // use maxZoom 19 to see stretched tiles instead of the BingMaps
        // "no photos at this zoom level" tiles
        // maxZoom: 19            maxZoom: 23
      }),
    }),
  );

  mapsAndTilesArray.push(
    new TileLayer({
      title: "Karte - Bing Satellit",
      visible: false,
      preload: Infinity,
      source: new BingMaps({
        key: "AtfmzTgvISAS9IXpA4S7NDMz0EG7EXkR_SWuy25sHz4LW6PqfqyQJ5x0deVFuujO",
        //            imagerySet: bingStyles[i],
        imagerySet: "Aerial",
        culture: "de-DE",
        // use maxZoom 19 to see stretched tiles instead of the BingMaps
        // "no photos at this zoom level" tiles
        // maxZoom: 19            maxZoom: 23
      }),
    }),
  );

  mapsAndTilesArray.push(
    new TileLayer({
      title: "Karte - Stadia Stamen Watercolor",
      visible: false,
      preload: Infinity,
      source: new StadiaMaps({
        layer: "stamen_watercolor",
        apiKey: "8a400c76-7f40-4581-8d1b-a2dbeb12df30",
      }),
    }),
  );

  mapsAndTilesArray.push(
    new TileLayer({
      title: "Karte - Stadia Stamen Toner-Lite",
      visible: false,
      preload: Infinity,
      source: new StadiaMaps({
        layer: "stamen_toner_lite",
        apiKey: "8a400c76-7f40-4581-8d1b-a2dbeb12df30",
      }),
    }),
  );

  mapsAndTilesArray.push(
    new ImageLayer({
      title: "Karte - ALKIS Saarland",
      name: "ALKIS Saarland",
      visible: false,
      opacity: 0.5,
      source: new ImageWMS({
        url: "https://geoportal.saarland.de/geobasisdaten/mapserv?map=/mapfiles/geobasisdaten/Internet/alkis.map",
        params: {
          SERVICE: "WMS",
          VERSION: "1.1.1",
          REQUEST: "GetMap",
          LAYERS: "WMS_SL_ALKIS",
          STYLES: "",
          FORMAT: "image/png",
          TRANSPARENT: true,
        },
        serverType: "mapserver",
        hidpi: false,
        ratio: 1,
      }),
    }),
  );

  /*
  mapsAndTilesArray.push(
    new TileLayer({
      title: "Karte - Stamen toner-lite",
      visible: false,
      preload: Infinity,
      source: new Stamen({
        layer: "toner-lite",
      }),
    })
  );*/

  /* !!! JAVASCRIPT Error !!!
  mapsAndTilesArray.push(
    new TileLayer({
      title: "Karte - AHocevar",
      visible: false,
      preload: Infinity,
      source: new Stamen({
        layer: "ahocevar-wms",
        url: "https://ahocevar.com/geoserver/wms",
      }),
    })
  );
  */

  mapsAndTilesArray.push(
    new TileLayer({
      title: "Karte - cartocdn",
      visible: false,
      preload: Infinity,
      source: new XYZ({
        url: "http://{1-4}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png",
      }),
    }),
  );

  // Create DWD Daten  Overlay
  mapsAndTilesArray.push(
    new TileLayer({
      title: "Overlay - DWD-Winddaten 10m",
      name: "Overlay- DWD-Winddaten 10m",
      visible: false,
      source: new TileWMS({
        url: "https://maps.dwd.de/geoserver/dwd/wms",
        params: {
          LAYERS: "dwd:BRD_1km_winddaten_10m",
          ownName: "Winddaten 10m",
        },
        serverType: "geoserver",
      }),
      opacity: 0.8,
    }),
  );

  mapsAndTilesArray.push(
    new ImageLayer({
      title: "Bodenübersichtskarte - ArcGis",
      name: "Bodenübersichtskarte- ArcGis",
      visible: false,
      source: new ImageArcGISRest({
        ratio: 1,
        params: {},
        url: "https://services.bgr.de/rest/services/boden/buek1000de/MapServer/",
      }),
    }),
  );

  mapsAndTilesArray.push(
    new TileLayer({
      title: "Overlay - DWD-Winddaten 80m",
      name: "Overlay- DWD-Winddaten 80m",
      visible: false,
      source: new TileWMS({
        url: "https://maps.dwd.de/geoserver/dwd/wms",
        params: {
          LAYERS: "dwd:BRD_1km_winddaten_80m",
          ownName: "Winddaten 80m",
        },
        serverType: "geoserver",
      }),
      opacity: 0.8,
    }),
  );

  mapsAndTilesArray.push(
    new TileLayer({
      title: "Overlay - DWD-Wetterwarnung",
      name: "Overlay- DWD-Wetterwarnung",
      visible: false,
      source: new TileWMS({
        url: "https://maps.dwd.de/geoserver/dwd/wms",
        params: {
          LAYERS: "dwd:Warnungen_Landkreise",
          ownName: "Wetterwarnung",
        },
        serverType: "geoserver",
      }),
      opacity: 0.8,
    }),
  );

  mapsAndTilesArray.push(
    new TileLayer({
      title: "Overlay - Windgeschwindigkeit",
      name: "Overlay- Windgeschwindigkeit",
      visible: false,
      source: new TileWMS({
        url: "https://cdc.dwd.de/geoserver/wms?service=WMS&version=1.3&request=GetMap&layers=OBS_DEU_PT1H_F&bbox=5.4,47.09,15.25,55.02&width=512&height=418&srs=EPSG:4326&format=image%2Fpng",
        params: { LAYERS: "OBS_DEU_PT1H_F", ownName: "Windgeschwindigkeit" },
        serverType: "geoserver",
      }),
      opacity: 0.8,
    }),
  );

  mapsAndTilesArray.push(
    new TileLayer({
      title: "Overlay - Windstärke",
      name: "Overlay- Windstärke",
      visible: false,
      source: new TileWMS({
        url: "https://cdc.dwd.de/geoserver/wms?service=WMS&version=1.3&request=GetMap&layers=OBS_DEU_P1M_F-K&bbox=5.4,47.09,15.25,55.02&width=512&height=418&srs=EPSG:4326&format=image%2Fpng",
        params: { LAYERS: "OBS_DEU_P1M_F-K", ownName: "Windstärke" },
        serverType: "geoserver",
      }),
      opacity: 0.8,
    }),
  );

  mapsAndTilesArray.push(
    new TileLayer({
      title: "Overlay - DWD: Niederschlag 24h",
      name: "Overlay- DWD-Niederschlag",
      visible: false,
      source: new TileWMS({
        url: "https://maps.dwd.de/geoserver/dwd/wms",
        params: { LAYERS: "dwd:RADOLAN-SY", ownName: "Niederschlag 24h" },
        serverType: "geoserver",
      }),
      opacity: 0.8,
    }),
  );

  mapsAndTilesArray.push(
    new TileLayer({
      title: "Overlay - DWD:Erdbodentemperatur in 1m Tiefe",
      name: "Overlay- DWD:Erdbodentemperatur in 1m Tiefe",
      visible: false,
      source: new TileWMS({
        url: "https://cdc.dwd.de/geoserver/wms?service=WMS&version=1.3&request=GetMap&layers=OBS_DEU_PT1H_TE100CM&bbox=5.4,47.09,15.25,55.02&width=512&height=418&srs=EPSG:4326&format=image%2Fpng",
        params: {
          LAYERS: "OBS_DEU_PT1H_TE100CM",
          ownName: "Erdbodentemperatur in 1m Tiefe",
        },
        serverType: "geoserver",
      }),
      opacity: 0.8,
    }),
  );

  mapsAndTilesArray.push(
    new TileLayer({
      title: "Overlay - DWD:Bodenfeuchte",
      name: "Overlay- DWD:Bodenfeuchte",
      visible: false,
      source: new TileWMS({
        url: "https://cdc.dwd.de/geoserver/wms?service=WMS&version=1.3&request=GetMap&layers=GRD_DEU_P1D_BF-GRB&bbox=5.4,47.09,15.25,55.02&width=512&height=418&srs=EPSG:4326&format=image%2Fpng",
        params: { LAYERS: "GRD_DEU_P1D_BF-GRB", ownName: "Bodenfeuchte" },
        serverType: "geoserver",
      }),
      opacity: 0.8,
    }),
  );

  mapsAndTilesArray.push(
    new TileLayer({
      title: "Overlay -DWD: Lufttemperatur in 2m Höhe P3M",
      name: "Overlay - DWD: Lufttemperatur in 2m Höhe P3M",
      visible: false,
      source: new TileWMS({
        url: "https://cdc.dwd.de/geoserver/wms?service=WMS&version=1.3&request=GetMap&layers=RGN_DEU_P1Y_T2M&bbox=5.4,47.09,15.25,55.02&width=512&height=418&srs=EPSG:4326&format=image%2Fpng",
        params: {
          LAYERS: "RGN_DEU_P1Y_T2M",
          ownName: "Lufttemperatur in 2m Höhe",
        },
        serverType: "geoserver",
      }),
      opacity: 0.8,
    }),
  );

  // Am 19.10.23 Entfernt da karten auslaufen.
  /* mapsAndTilesArray.push(
    new TileLayer({
      title: "Overlay - Stamen watercolor",
      visible: false,
      preload: Infinity,
      source: new Stamen({
        layer: "watercolor",
      }),
    })
  );*/

  // Create All Trees as tile Layer
  mapsAndTilesArray.push(
    new TileLayer({
      title: "Bäume - Alle",
      name: "Bäume - Alle",
      visible: false,
      source: new TileWMS({
        url: wmsUrl,
        params: { LAYERS: "treeclimatedb:treesimport", TILED: true },
        serverType: "geoserver",
      }),
    }),
  );

  const stylePolygon = [
    /* We are using two different styles for the polygons:
     *  - The first style is for the polygons themselves.
     *  - The second style is to draw the vertices of the polygons.
     *    In a custom `geometry` function the vertices of a polygon are
     *    returned as `MultiPoint` geometry, which will be used to render
     *    the style.
     */
    new Style({
      stroke: new Stroke({
        color: "blue",
        width: 3,
      }),
      fill: new Fill({
        color: "rgba(0, 0, 255, 0.1)",
      }),
    }),
    new Style({
      image: new CircleStyle({
        radius: 5,
        fill: new Fill({
          color: "orange",
        }),
      }),
      geometry: function (feature) {
        // return the coordinates of the first ring of the polygon
        const coordinates = feature.getGeometry().getCoordinates()[0];
        return new MultiPoint(coordinates);
      },
    }),
  ];

  /*
  // Create All Bestände as tile Layer
  mapsAndTilesArray.push(
    new TileLayer({
      title: "Waldähnliche Bestände (WAB) - Alle",
      name: "WAB",
      visible: false,
      source: new TileWMS({
        url: wmsUrl,
        params: { LAYERS: "treeclimatedb:geometries", TILED: true },
        serverType: "geoserver",
        style: stylePolygon,
      }),
    })
  );*/

  // PLZ LAYER Test
  mapsAndTilesArray.push(
    new VectorLayer({
      title: "ESRI - Gemarkungen nach PLZ (lange Ladezeit)",
      name: "ESRI - Gemarkungen nach PLZ",
      visible: false,
      source: new VectorSource({
        format: new GeoJSON(),
        url: "https://services2.arcgis.com/jUpNdisbWqRpMo35/arcgis/rest/services/PLZ_Gebiete/FeatureServer/0/query?outFields=*&where=1%3D1&f=geojson",
      }),
    }),
  );

  return mapsAndTilesArray;
}

/**
 * Layerswitcher erstellen und auf Karte hinzufügen
 *
 * @export
 * @return {*} Das Layerswitcher Menu
 */
export function createLayerSwitcher() {
  return new LayerSwitcher({
    reverse: true,
    groupSelectStyle: "group",
    activationMode: "click",
    startActive: true,
    tipLabel: "Layers", // Optional label for button
    groupSelectStyle: "children", // Can be 'children' [default], 'group' or 'none'
    collapseTipLabel: "Collapse layers",
  });
}

/**
 * Gibt ein Array mit den Layern einer Karte aus
 *
 * @export
 * @param {*} map Referenz zur Map
 * @return {*} Array mit kartenlayern
 */
export function getMapLayers(map) {
  return map.getLayers();
}

/**
 * Löscht einen Layer von der Karte
 *
 *
 * @param {Name des zu loeschenden Layers} layerName
 * @param {Karte von welchjer der Layer geloescht werden soll} map
 */
export function removeMapLayer(map, layerName) {
  map
    .getLayers()
    .getArray()
    .filter((layer) => layer.get("title") === layerName)
    .forEach((layer) => map.removeLayer(layer));
}

/**
 * Versteckt einen Layer von der Karte
 *
 * @param {Name des zu versteckenden Layers} layerName
 * @param {Karte von welchjer der Layer geloescht werden soll} map
 */
export function hideLayer(map, layerName) {
  let actualMap = getActualMap();
  actualMap.globalMap
    .getLayers()
    .getArray()
    .filter((layer) => layer.get("title") === layerName)
    .forEach((layer) => layer.setVisible(false));
}

/**
 * CENTERS MAP ON COORDINATES
 *
 * @param {*} long
 * @param {*} lat
 * @return {*}
 */
export function centerMap(long, lat, newZoom) {
  // Prüfen ob Long und Lat gesetzt sind
  if (long == null || lat == null) {
    return;
  }

  const newCenterView = fromLonLat([lat, long]);
  let actualMap = getActualMap();
  let view = actualMap.globalView;

  flyTo(newCenterView, view, newZoom, function () {});
}

/**
 * Funktion um die Animation zu ermöglichen
 *
 * @param {*} location
 * @param {*} done
 */
function flyTo(location, view, newZoom, done) {
  const duration = 2000;
  let zoom;
  if (newZoom) {
    zoom = newZoom;
  } else {
    zoom = view.getZoom();
  }
  let parts = 2;
  let called = false;
  function callback(complete) {
    --parts;
    if (called) {
      return;
    }
    if (parts === 0 || !complete) {
      called = true;
      done(complete);
    }
  }
  view.animate(
    {
      center: location,
      duration: duration,
    },
    callback,
  );
  view.animate(
    {
      zoom: 10,
      duration: duration / 2,
    },
    {
      zoom: zoom,
      duration: duration / 2,
    },
    callback,
  );
}

export function zeigeAlleFlaechenAn(flaechen, map) {
  // Remove the existing layer with the specified title
  removeMapLayer(map, "Waldähnliche Bestände (WAB) - Suchergebnis");

  const polygonFeatures = [];

  // Fuer Alle Flaechen
  flaechen.forEach((flaeche) => {
    const transformierteKoordinaten = [];

    // Transformieren der Koordninaten
    flaeche.geometry.coordinates[0].forEach((element) => {
      transformierteKoordinaten.push(
        transform(element, "EPSG:4326", "EPSG:3857"),
      );
    });

    // Erstellen neues Polygon mit transformierten Koordinaten
    const polygon = new Polygon([transformierteKoordinaten]);

    // Erstellen eines Polygon Features
    const polygonFeature = new Feature({
      id: flaeche.id,
      type: "Flaeche",
      geometry: polygon,
      eigenschaften: flaeche.properties,
    });

    // Hinzufügen zur Liste aller Polygon-Features
    polygonFeatures.push(polygonFeature);
  });

  // Erstellen Polygon-Style
  const polygonStyle = [
    new Style({
      stroke: new Stroke({
        color: "rgba(0, 255, 0, 0.8)",
        width: 3,
      }),
      fill: new Fill({
        color: "rgba(0, 220, 60, 0.3)",
      }),
    }),
    new Style({
      image: new CircleStyle({
        radius: 5,
        fill: new Fill({
          color: "rgba(0, 255, 0, 0.6)",
        }),
      }),
      geometry: function (feature) {
        // return the coordinates of the first ring of the polygon
        const coordinates = feature.getGeometry().getCoordinates()[0];
        return new MultiPoint(coordinates);
      },
    }),
  ];

  // Erstellen eines Layers mit allen Polygon-Features
  const polygonLayer = new VectorLayer({
    title: "Waldähnliche Bestände (WAB) - Suchergebnis",
    name: "Waldähnliche Bestände (WAB) - Suchergebnis",
    source: new VectorSource({
      features: polygonFeatures,
    }),
    style: polygonStyle,
  });

  // Anzeigen des Layers mit allen Polygon-Features
  map.addLayer(polygonLayer);
}

export function zeigeFlaecheAn(flaeche, map) {
  // Remove the existing layer with the specified title
  removeMapLayer(map, "Waldähnliche Bestände (WAB) - Suchergebnis");

  const transformierteKoordinaten = [];

  // Transformieren der Koordninaten
  flaeche.geometry.coordinates[0].forEach((element) => {
    transformierteKoordinaten.push(
      transform(element, "EPSG:4326", "EPSG:3857"),
    );
  });

  // Erstellen neues Polygon mit transformierten Koordinaten
  const polygon = new Polygon([transformierteKoordinaten]);

  // Erstellen eines Polygon Features
  const polygonFeature = new Feature({
    geometry: polygon,
  });

  // Erstellen Polygon-Style
  const polygonStyle = [
    new Style({
      stroke: new Stroke({
        color: "blue",
        width: 3,
      }),
      fill: new Fill({
        color: "rgba(0, 0, 255, 0.1)",
      }),
    }),
    new Style({
      image: new CircleStyle({
        radius: 5,
        fill: new Fill({
          color: "orange",
        }),
      }),
      geometry: function (feature) {
        // return the coordinates of the first ring of the polygon
        const coordinates = feature.getGeometry().getCoordinates()[0];
        return new MultiPoint(coordinates);
      },
    }),
  ];

  // Erstellen eines Layers mit allen Polygon-Features
  const polygonLayer = new VectorLayer({
    title: "Waldähnliche Bestände (WAB) - Suchergebnis",
    name: "Waldähnliche Bestände (WAB) - Suchergebnis",
    source: new VectorSource({
      features: [polygonFeature],
    }),
    style: polygonStyle,
  });

  // Anzeigen des Layers mit allen Polygon-Features
  map.addLayer(polygonLayer);
}
